import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SubfooterRequestUpdate } from '../../../../models/api-store/subfooter/subfooter.request.model';
import { SubfooterService } from '../../../../services/api-store/subfooter/subfooter.service';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-subfooter-edit',
  templateUrl: './subfooter-edit.component.html'
})
export class SubfooterEditComponent implements OnInit {

  @Input() public id:number;
  formBuilder: FormGroup;
  request:any = {};
  isButtonSaveDisabled:boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private spinner: SpinnerService,
    private subfooterService: SubfooterService,
    private toastr: ToastrService,
  ) { 
    this.initForm();
  }

  ngOnInit(): void {
    this.loadDataByID(this.id);
  }

  get form(){return this.formBuilder;}
  get formControls() { return this.formBuilder.controls; }

  initForm(){
    this.formBuilder = this.fb.group({
      province: ['',[Validators.required]],
      index: [0,[Validators.required,Validators.min(0)]],
    });
    this.isButtonSaveDisabled = false;
  }

  loadDataByID(id){
    this.subfooterService.getEntity(id).subscribe(
      (response) => {
        if(response){
          this.setFormValue(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni della sezione' , 'Load sezione', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  getValue(){
    let request = new SubfooterRequestUpdate();
    request.province = this.formBuilder.controls['province'].value;
    request.index = this.formBuilder.controls['index'].value;
    return request;
  }

  setFormValue(response){
    this.formBuilder.controls['province'].setValue(response.province);
    this.formBuilder.controls['index'].setValue(response.index);
  }

  save(){
    this.request = this. getValue();
    this.subfooterService.update(this.id,this.request).subscribe(
      (response) => {
        if(response){
          //Salvato
          this.toastr.success('Subfooter modificato con successo', 'Modifica subfooter');
          this.isButtonSaveDisabled = true;
          this.activeModal.close(response);
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.isButtonSaveDisabled = true;
        this.toastr.error('Si è verificato un errore durante la modifica del subfooter' , 'Modifica subfooter fallita', {
            timeOut: 5000
        });
      }
    );
  }

  clickButtonSave(){
    if(this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE){
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }
}
